import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import BaseComponent from "../../baseComponent.js";
import FunctionList from "./functions/functionList.jsx";
import FunctionDetail  from "./functions/detail/functionDetail.jsx";
import ColorUtil from "../../../core/utils/colorUtil.js";
import InternalEvent from "../../../core/constants/internalEvent.js";

export default class FormulaBar extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      functionDetail: null,
      functionAndDatasetList: [],
      argIndex: -1
    };
  }

  componentWillMount() {
    this.keys = {
      backspace: 8,
      tab: 9,
      enter: 13,
      shift: 16,
      ctrl: 17,
      alt: 18,
      esc: 27,
      space: 32,
      left: 37,
      up: 38,
      right: 39,
      down: 40
    };

    this.INSERTION_TYPE = {
      NONE: 0,
      INSERT: 1,
      REPLACE: 2
    };
    this.insertionIndicators = "(,+-*/=";
    this.dataProfileCache = [];
    this.functionAndDatasetList = require('../../../core/constants/functionDescription.js');
    // a cell which has highlighted background
    this.backgroundHighlightedCell = null;
    // set of cells which have highlighted border
    this.highightedCellElements = [];
    this.insertTargetElementIndex = -1;
    this.insertionMode = this.INSERTION_TYPE.NONE;
    // function detail popup style(minimized or not)
    this.minimized = true;
  }

  componentWillUpdate(nextProps, nextState) {
    var _this = this;
    if (this.props.formula.value == nextProps.formula.value) return;

    if (this.props.formula.datasetRefId !== nextProps.formula.datasetRefId ||
      this.props.formula.fieldId !== nextProps.formula.fieldId) {
      this.state.functionDetail = null;
      this.state.functionAndDatasetList = [];
    }

    var lastSpan = null;
    this.resetHighlightedCellElements();
    this.resetHighlightCellBackground();
    this.resetSpanColors();
    $(this.refs.formulaBar).empty();
    if (nextProps.formula.value) {
      var parsed = this.parseRawFormula(nextProps.formula.value);
      for (var i = 0; i < parsed.length; i++) {
        lastSpan = this.insertFormulaSpan(parsed[i]);
      }

      var selection = window.getSelection();
      var range = document.createRange();
      var anchorNodeToMove = null;
      if (this.insertionMode === this.INSERTION_TYPE.REPLACE) {
        anchorNodeToMove = this.refs.formulaBar.childNodes[this.insertTargetElementIndex];
        range.setStartAfter(anchorNodeToMove);
        anchorNodeToMove.classList.add("f-span--replaceable");
      } else if (lastSpan) {
        range.setStartAfter(lastSpan);
      }

      // setting timeout because selection change by clicking cell happens after this manual change
      setTimeout(function () {
        selection.removeAllRanges();
        selection.addRange(range);
        _this.highlightCellBackground(anchorNodeToMove);
        // _this.setReplaceMode();
      }, 100);
    }
  }

  componentWillUnmount() {
    this.unsubscribeAll();
  }

  componentDidMount() {
    this.formulaBar = $(this.refs.formulaBar);
    this.subscribe(InternalEvent.Studio.SPREADSHEET_CELL_CLICKED, this.handleCellClickedEvent);
  }

  toggleContent() {
    this.minimized = !this.minimized;
  }

  handleCellClickedEvent(text) {
    if (this.insertionMode === this.INSERTION_TYPE.NONE) return;

    var targetSpan = this.refs.formulaBar.childNodes[this.insertTargetElementIndex];
    if (targetSpan == null) targetSpan = this.insertFormulaSpan("");

    if (this.insertionMode === this.INSERTION_TYPE.INSERT) {
      var trimContent = targetSpan.textContent.trim();
      if (trimContent.length > 0 && this.insertionIndicators.indexOf(trimContent) > -1) {
        this.insertTargetElementIndex++;
      }
      targetSpan.textContent = targetSpan.textContent + text;
      this.insertionMode = this.INSERTION_TYPE.REPLACE;
    } else if (this.insertionMode === this.INSERTION_TYPE.REPLACE) {
      var spaces = this.getLeadingWhiteSpaces(targetSpan.textContent);
      targetSpan.textContent = spaces + text;
    }

    this.props.updateFormula(this.refs.formulaBar.textContent);
    this.highlightCellBackground();
  }

  handleClick() {
    this.setReplaceMode();
    this.showPopup();
  }

  showPopup() {
    this.highlightCellBackground();
    var nodeAtSelection = this.getSelectionContainerElement();
    var spans = this.formulaBar.find("span");
    var indexOfSelectedNode = $(spans).index(nodeAtSelection);
    var closeParenthesesIndex = -1, openParenthesesIndex = -1;

    if (spans.length === 0) {
      this.hidePopup();
      return;
    }

    this.formulaBar.find(".focused").removeClass("focused");
    this.formulaBar.find(".blurred").removeClass("blurred");

    switch (nodeAtSelection.textContent) {
      case "(": {
        openParenthesesIndex = indexOfSelectedNode;
        closeParenthesesIndex = findMatchingCloseParentheses(indexOfSelectedNode);
        break;
      }
      case ")": {
        openParenthesesIndex = findMatchingOpenParentheses(indexOfSelectedNode);
        closeParenthesesIndex = indexOfSelectedNode;
        break;
      }
      default: {
        openParenthesesIndex = findMatchingOpenParentheses(indexOfSelectedNode);
        closeParenthesesIndex = findMatchingCloseParentheses(indexOfSelectedNode);
      }
    }

    // highlight parentheses if found matching
    if (openParenthesesIndex != -1 && closeParenthesesIndex != -1) {
      $(spans[openParenthesesIndex]).addClass("focused");
      $(spans[closeParenthesesIndex]).addClass("focused");
      highlightRange(openParenthesesIndex, closeParenthesesIndex);
    }

    var popupDisplayed = false;
    var functionName = "", argIndex = -1, nextSpan = spans[indexOfSelectedNode + 1];

    // if the next span is "(", the current selection is function
    if (nextSpan && nextSpan.textContent === "(") {
      functionName = spans[indexOfSelectedNode].textContent.trim();
      argIndex = findArgumentIndex(indexOfSelectedNode + 2);
      popupDisplayed = this.showFunctionDetail(functionName, argIndex);
    }

    // if the last character of the current node is ".", try to find data profile
    if (nodeAtSelection.textContent[nodeAtSelection.textContent.length - 1] === ".") {
      var datasetRef = nodeAtSelection.textContent.substr(0, nodeAtSelection.textContent.length - 1);
      var searchResult = this.getFunctionOrDatasetList(datasetRef);
      if (searchResult.length === 1) {
        popupDisplayed = this.showDataProfileDetail(searchResult[0].dataProfileId, datasetRef);
      }
    }

    var split = nodeAtSelection.textContent.split(".");
    if (split.length === 2) {
      var datasetRef = split[0].trim();
      var searchResult = this.getFunctionOrDatasetList(datasetRef);
      if (searchResult.length === 1) {
        popupDisplayed = this.showDataProfileDetail(searchResult[0].dataProfileId, datasetRef, split[1]);
      }
    }

    // show function and dataset list(from inputs)
    if (!popupDisplayed && nodeAtSelection.textContent.length > 0) {
      popupDisplayed = this.showFunctionAndDatasetList(nodeAtSelection.textContent);
    }

    // find function at the cursor and show detail
    if (!popupDisplayed && openParenthesesIndex > 0) {
      functionName = spans[openParenthesesIndex - 1].textContent.trim();
      argIndex = findArgumentIndex(openParenthesesIndex + 1);
      popupDisplayed = this.showFunctionDetail(functionName, argIndex);
    }

    // if nothing to show, hide it
    if (!popupDisplayed) {
      this.hidePopup();
    }

    function findArgumentIndex(startIndex) {
      var index = 0;
      for (var i = startIndex; i < spans.length; i++) {
        var t = spans[i].textContent.trim();
        if (spans[i] === spans[indexOfSelectedNode]) {
          if (t === ",") index++;
          return index;
        } else {
          if (t === "(") {
            // found open parentheses. skip to the end
            i = findMatchingCloseParentheses(i);
          } else if (t === ",") {
            index++;
          }
        }
      }

      // nothing found. highlight the first arg
      return 0;
    }

    function findMatchingOpenParentheses(startIndex) {
      var numCloseParentheses = 0;
      for (var i = startIndex - 1; i >= 0; i--) {
        if (spans[i].textContent === ")") {
          numCloseParentheses++;
        } else if (spans[i].textContent === "(") {
          if (numCloseParentheses === 0) {
            return i;
          } else {
            numCloseParentheses--;
          }
        }
      }

      return -1;
    }

    function findMatchingCloseParentheses(startIndex) {
      var numOpenParentheses = 0;
      for (var i = startIndex + 1; i < spans.length; i++) {
        if (spans[i].textContent === "(") {
          numOpenParentheses++;
        } else if (spans[i].textContent === ")") {
          if (numOpenParentheses === 0) {
            return i;
          } else {
            numOpenParentheses--;
          }
        }
      }

      return -1;
    }

    function highlightRange(start, end) {
      for (var i = 0; i < spans.length; i++) {
        if (i < start - 1 || i > end) {
          $(spans[i]).addClass("blurred");
        }
      }
    }
  }

  hidePopup() {
    this.setState({
      functionAndDatasetList: [],
      functionDetail: null
    })
  }

  // TODO: Remove hard-coded stuff and using the service
  showDataProfileDetail(dataProfileId, ref, searchString) {
    var mockData = JSON.parse('{"persistenceId":"e0c8e869-750c-4b4e-8a46-8d2317622c0e","name":"LpSnapshot","fields":[{"name":"Level 1 Bid Price","valueType":2,"maxLength":0,"fieldId":"bidPrice0"},{"name":"Level 1 Bid Quantity","valueType":2,"maxLength":0,"fieldId":"bidQty0"},{"name":"Level 1 Price Executable","valueType":7,"maxLength":0,"fieldId":"bidExec0"},{"name":"Level 2 Bid Price","valueType":2,"maxLength":0,"fieldId":"bidPrice1"},{"name":"Level 2 Bid Quantity","valueType":2,"maxLength":0,"fieldId":"bidQty1"},{"name":"Level 2 Bid Price Executable","valueType":7,"maxLength":0,"fieldId":"bidExec1"},{"name":"Level 3 Bid Price","valueType":2,"maxLength":0,"fieldId":"bidPrice2"},{"name":"Level 3 Bid Quantity","valueType":2,"maxLength":0,"fieldId":"bidQty2"},{"name":"Level 3 Bid Price Executable","valueType":7,"maxLength":0,"fieldId":"bidExec2"},{"name":"Level 4 Bid Price","valueType":2,"maxLength":0,"fieldId":"bidPrice3"},{"name":"Level 4 Bid Quantity","valueType":2,"maxLength":0,"fieldId":"bidQty3"},{"name":"Level 4 Bid Price Executable","valueType":7,"maxLength":0,"fieldId":"bidExec3"},{"name":"Level 5 Bid Price","valueType":2,"maxLength":0,"fieldId":"bidPrice4"},{"name":"Level 5 Bid Quantity","valueType":2,"maxLength":0,"fieldId":"bidQty4"},{"name":"Level 5 Bid Price Executable","valueType":7,"maxLength":0,"fieldId":"bidExec4"},{"name":"Level 1 Ask Price","valueType":2,"maxLength":0,"fieldId":"askPrice0"},{"name":"Level 1 Ask Quantity","valueType":2,"maxLength":0,"fieldId":"askQty0"},{"name":"Level 1 Ask Price Executable","valueType":7,"maxLength":0,"fieldId":"askExec0"},{"name":"Level 2 Ask Price","valueType":2,"maxLength":0,"fieldId":"askPrice1"},{"name":"Level 2 Ask Quantity","valueType":2,"maxLength":0,"fieldId":"askQty1"},{"name":"Level 2 Ask Price Executable","valueType":7,"maxLength":0,"fieldId":"askExec1"},{"name":"Level 3 Ask Price","valueType":2,"maxLength":0,"fieldId":"askPrice2"},{"name":"Level 3 Ask Quantity","valueType":2,"maxLength":0,"fieldId":"askQty2"},{"name":"Level 3 Ask Price Executable","valueType":7,"maxLength":0,"fieldId":"askExec2"},{"name":"Level 4 Ask Price","valueType":2,"maxLength":0,"fieldId":"askPrice3"},{"name":"Level 4 Ask Quantity","valueType":2,"maxLength":0,"fieldId":"askQty3"},{"name":"Level 4 Ask Price Executable","valueType":7,"maxLength":0,"fieldId":"askExec3"},{"name":"Level 5 Ask Price","valueType":2,"maxLength":0,"fieldId":"askPrice4"},{"name":"Level 5 Ask Quantity","valueType":2,"maxLength":0,"fieldId":"askQty4"},{"name":"Level 5 Ask Price Executable","valueType":7,"maxLength":0,"fieldId":"askExec4"},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0}],"description":"Structure storing multiple levels of pricing","createdByOrganization":"4cc27103-e155-420b-785a-6a78478b1092","createdByUser":"2b4e3261-6368-5954-7459-58784d6a7444"}');
    var dataProfile = null;
    for (var i = 0; i < this.dataProfileCache.length; i++) {
      if (this.dataProfileCache[i].persistenceId === dataProfileId) {
        dataProfile = this.dataProfileCache[i];
        break;
      }
    }

    var previewList = [];
    if (dataProfile === null) {

      for (var i = 0; i < mockData.fields.length; i++) {
        if (mockData.fields[i].hasOwnProperty("fieldId")) {
          if (searchString) {
            if (mockData.fields[i].fieldId.substr(0, searchString.length) != searchString) continue;
          }
          previewList.push({
            name: mockData.fields[i].fieldId,
            summary: mockData.fields[i].name,
            type: ref
          });
        }
      }

      this.setState({
        functionAndDatasetList: previewList,
        functionDetail: null
      })
    }

    return previewList.length !== 0;
  }

  showFunctionDetail(functionName, argIndex) {
    var fn = this.getFunction(functionName);
    if (fn != null) {
      this.setState({
        functionDetail: fn,
        argIndex: argIndex,
        functionAndDatasetList: []
      });
    }

    return fn !== null;
  }

  showFunctionAndDatasetList(searchText) {
    var list = this.getFunctionOrDatasetList(searchText.trim());
    if (list.length > 0) {
      this.setState({
        functionDetail: null,
        functionAndDatasetList: list
      });
    }

    return list.length !== 0;
  }

  setInsertMode(spans, nodeAtSelection) {
    var selectedNodeIndex = spans.index(nodeAtSelection);
    var content = nodeAtSelection.textContent.trim();
    this.insertionMode = false;

    if (spans.length === 0) {
      this.insertionMode = this.INSERTION_TYPE.INSERT;
      this.insertTargetElementIndex = 0;
    } else if (this.insertionIndicators.indexOf(content) > -1) {
      this.insertionMode = this.INSERTION_TYPE.INSERT;
      this.insertTargetElementIndex = selectedNodeIndex;
    } else if (content.length > 1) {
      if (this.insertionIndicators.indexOf(content.slice(-1)) > -1) {
        this.insertionMode = this.INSERTION_TYPE.INSERT;
        var parsed = this.parseRawFormula(content);
        this.insertTargetElementIndex = selectedNodeIndex + parsed.length - 1;
      }
    } else {
      var prevNode = spans[selectedNodeIndex - 1];
      var nextNode = spans[selectedNodeIndex + 1];
      if (prevNode && nextNode) {
        if (prevNode.textContent.trim() === "," &&
          nextNode.textContent.trim() === ",") {
          this.insertionMode = this.INSERTION_TYPE.INSERT;
          this.insertTargetElementIndex = selectedNodeIndex;
        }
      }
    }

    if (this.props.changeInsertMode) {
      this.props.changeInsertMode(this.insertionMode);
    }
  }

  setReplaceMode() {
    this.insertionMode = this.INSERTION_TYPE.NONE;
    var nonReplaceable = "=+-*/()[],";
    var targetElement = this.getSelectionContainerElement();
    var spans = this.formulaBar.find("span");

    if (targetElement.tagName === "DIV") {
      targetElement = spans[spans.length - 1];
      if (targetElement == null) {
        targetElement = this.insertFormulaSpan("");
        spans = this.formulaBar.find("span");
      }
    }

    var targetElementIndex = $(spans).index(targetElement);
    var textContent = targetElement.textContent.trim();
    var isReplaceable = true;

    var replaceable = document.querySelector(".f-span--replaceable");
    if (replaceable) replaceable.classList.remove("f-span--replaceable");

    if (textContent.length > 1) {
      var nextElement = spans[targetElementIndex + 1];
      if (nextElement) {
        var nextElementContent = nextElement.textContent.trim();
        if (nextElementContent === "(") isReplaceable = false;
      }
    } else if (textContent.length === 1) {
      if (nonReplaceable.indexOf(textContent) > -1) {
        isReplaceable = false;
      }
    }

    if (isReplaceable) {
      this.insertionMode = this.INSERTION_TYPE.REPLACE;
      this.insertTargetElementIndex = targetElementIndex;
      targetElement.classList.add("f-span--replaceable");
    }

    if (this.props.changeInsertMode) {
      this.props.changeInsertMode(this.insertionMode);
    }
  }

  getFunctionOrDatasetList(keyword) {
    var result = [];
    if (keyword.length > 0) {
      for (var i = 0; i < this.functionAndDatasetList.length; i++) {
        var formulaName = this.functionAndDatasetList[i].name.toLowerCase();
        keyword = keyword.toLowerCase();
        if (formulaName.startsWith(keyword)) result.push(this.functionAndDatasetList[i]);
      }
    }
    return result;
  }

  getFunction(fnName) {
    var result = null;
    for (var i = 0; i < this.functionAndDatasetList.length; i++) {
      var name = this.functionAndDatasetList[i].name.toLowerCase();
      fnName = fnName.toLowerCase();
      if (name === fnName) return this.functionAndDatasetList[i];
    }

    return result;
  }

  reset() {
    var replaceable = document.querySelector(".f-span--replaceable");
    if (replaceable) replaceable.classList.remove("f-span--replaceable");
    this.insertionMode = this.INSERTION_TYPE.NONE;
    this.resetHighlightedCellElements();
    window.getSelection().removeAllRanges();
    if (this.backgroundHighlightedCell) {
      this.backgroundHighlightedCell.style.background = null;
      this.backgroundHighlightedCell = null;
    }
    this.props.formula.value = "";
    if (this.props.changeInsertMode) {
      this.props.changeInsertMode(false);
    }

    this.hidePopup();
    this.props.updateFormula(this.refs.formulaBar.textContent, false, true);
  }

  highlightCellBorder(targetCellElement, color) {
    if (targetCellElement) {
      var valueCell = targetCellElement.childNodes[1];
      this.highightedCellElements.push(valueCell);
      valueCell.style.border = "2px dashed " + color;
    }
  }

  resetHighlightedCellElements() {
    for (var i = 0; i < this.highightedCellElements.length; i++) {
      this.highightedCellElements[i].style.border = null;
    }
    this.highightedCellElements = [];
  }

  highlightCellBackground(formulaSpanElement) {
    var targetElement = formulaSpanElement || this.getSelectionContainerElement();
    var textContent = targetElement.textContent.trim();
    var cellElement = document.getElementById(textContent);
    this.resetHighlightCellBackground();
    if (cellElement && targetElement) {
      var color = targetElement.getAttribute("data-color");
      if (color) {
        var bgColor = ColorUtil.shadeColor(color, -20);
        var rgb = ColorUtil.toRgb(bgColor);
        var rgba = "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + 0.1 + ")";
        cellElement.childNodes[1].style.backgroundColor = rgba;
        this.backgroundHighlightedCell = cellElement.childNodes[1];
      }
    }
  }

  resetHighlightCellBackground() {
    if (this.backgroundHighlightedCell) {
      this.backgroundHighlightedCell.style.background = null;
    }
  }

  resetSpanColors() {
    this.colors = this.props.colors.slice();
  }

  insertFormulaSpan(content) {
    var el = document.createElement("span");

    if (!isNaN(parseFloat(content))) {
      el.classList.add("f-span--numeric");
    } else if (content.split(".").length === 2) {
      if (this.props.eval([content.trim()]) !== "ERROR") {
        var color = this.colors.shift();
        el.style.color = color;
        el.setAttribute("data-color", color);
        var cellElement = document.getElementById(content.trim());
        this.highlightCellBorder(cellElement, color);
      }
    }

    el.classList.add("f-span");
    el.textContent = content;
    this.refs.formulaBar.appendChild(el);

    return el;
  }

  getLeadingWhiteSpaces(text) {
    var spaces = "";
    for (var i = 0; i < text.length; i++) {
      if (text[i] === " " || text[i] === "\xa0") {
        spaces += " ";
      }
    }
    return spaces;
  }

  parseRawFormula(text) {
    var regex = /([\=\+\-\*\/\(\)\,\[\]])/;
    var parsed = text.split(regex);

    var index = parsed.length;
    while (index--) {
      if (parsed[index] === "") parsed.splice(index, 1);
    }

    var result = [], quote = null, temp = "";
    for (var i = 0; i < parsed.length; i++) {
      if (parsed[i] === "[") {
        quote = '[';
      } else if (parsed[i] === "]") {
        if (quote !== null) {
          temp += parsed[i];
          if (quote == "[") quote = null;
        }
      } else if (parsed[i].indexOf("'") > -1) {
        if (quote === null) {
          quote = "'";
        } else if (quote === "'") {
          temp += parsed[i];
          quote = null;
        }
      } else if (parsed[i].indexOf('"') > -1) {
        if (quote === null) {
          quote = '"';
        } else if (quote === '"') {
          temp += parsed[i];
          quote = null;
        }
      }

      if (quote === null) {
        if (temp === "") {
          result.push(parsed[i]);
        } else {
          result.push(temp);
        }
        temp = "";
      } else {
        temp += parsed[i];
      }
    }
    if (temp !== "") result.push(temp);

    return result;
  }

  getSelectionContainerElement() {
    var range, sel, container;
    sel = window.getSelection();
    if (sel.getRangeAt) {
      if (sel.rangeCount > 0) {
        range = sel.getRangeAt(0);
      }
    } else {
      range = document.createRange();
      range.setStart(sel.anchorNode, sel.anchorOffset);
      range.setEnd(sel.focusNode, sel.focusOffset);

      if (range.collapsed !== sel.isCollapsed) {
        range.setStart(sel.focusNode, sel.focusOffset);
        range.setEnd(sel.anchorNode, sel.anchorOffset);
      }
    }

    if (range) {
      container = range.commonAncestorContainer;
      return container.nodeType === 3 ? container.parentNode : container;
    }
  }

  handleKeyUp(e) {
    var list = $("#formula-list");
    var options = list.find("li");
    var dataProfileId = null, ref = null;
    switch (e.keyCode) {
      case this.keys.up:
      case this.keys.down: {
        e.preventDefault();
        return false;
      }
      case this.keys.esc: {
        this.reset();
        break;
      }
      case this.keys.right:
      case this.keys.left:
      case this.keys.space: {
        this.showPopup();
        e.preventDefault();
        return false;
      }
      case this.keys.enter:
      case this.keys.tab: {
        var anchorNode = window.getSelection().anchorNode;
        var currentOption = options.filter('.selected');
        var currentOptionIndex = options.index(currentOption);
        if (currentOptionIndex > -1) {
          var selected = this.state.functionAndDatasetList[currentOptionIndex];
          var contentToReplace = "";

          switch (selected.type) {
            case "dataset": {
              contentToReplace = selected.name + ".";
              ref = selected.name;
              dataProfileId = selected.dataProfileId;
              break;
            }
            case "math":
            case "financial": {
              contentToReplace = selected.name + "(";
              break;
            }
            default: {
              // dataset field
              contentToReplace = anchorNode.textContent.split(".")[0] + "." + selected.name;
            }
          }

          var spaces = this.getLeadingWhiteSpaces(anchorNode.textContent);
          anchorNode.textContent = spaces + contentToReplace;
        } else {
          this.reset();
          break;
        }
      }
      default: {
        var anchorNodeToMove = null;
        var prevRange = window.getSelection().getRangeAt(0);
        var prevRangeStartOffset = prevRange.startOffset;
        var prevRangeEndOffset = prevRange.endOffset;
        var parsed = this.parseRawFormula(e.currentTarget.textContent);
        var nodeAtSelection = this.getSelectionContainerElement();
        // somehow, font element is inserted into span
        if (nodeAtSelection.nodeName === "FONT") {
          nodeAtSelection = nodeAtSelection.parentElement;
        }
        var spans = this.formulaBar.find("span");
        // index of the selection span of formula node
        var parsedNodeContent = this.parseRawFormula(nodeAtSelection.textContent);
        // will use this index after re-construct span nodes as the current caret position
        var indexOfSelectedNode = $(spans).index(nodeAtSelection);
        // when formula is empty, the first span element will be created
        // so set index of the selection span to 0
        if (indexOfSelectedNode == -1) indexOfSelectedNode = 0;

        if (parsedNodeContent.length > 1) {
          if (parsedNodeContent[0] === " ") {
            indexOfSelectedNode += parsedNodeContent.length - 2;
          } else {
            indexOfSelectedNode += parsedNodeContent.length - 1;
            prevRangeStartOffset = parsedNodeContent[parsedNodeContent.length - 1].length;
            prevRangeEndOffset = parsedNodeContent[parsedNodeContent.length - 1].length;
          }
        }

        this.setInsertMode(spans, nodeAtSelection);
        e.currentTarget.innerHTML = "";
        this.resetSpanColors();
        this.resetHighlightedCellElements();
        for (var i = 0; i < parsed.length; i++) {
          var span = this.insertFormulaSpan(parsed[i]);
          // will use this node to set the cursor
          if (i === indexOfSelectedNode) anchorNodeToMove = span;
        }

        this.props.updateFormula(e.currentTarget.textContent, true);

        if (anchorNodeToMove) {
          var selection = window.getSelection();
          var range = document.createRange();
          range.setStart(anchorNodeToMove.firstChild, prevRangeStartOffset);
          range.setEnd(anchorNodeToMove.firstChild, prevRangeEndOffset);
          selection.removeAllRanges();
          selection.addRange(range);
        }

        if (dataProfileId) {
          this.showDataProfileDetail(dataProfileId, ref)
        } else {
          this.showPopup(dataProfileId);
        }
      }
    }
  }

  handleKeyDown(e) {
    var list = $("#formula-list");
    var options = list.find("li");
    var currentOption = options.filter('.selected');
    var currentIndex = options.index(currentOption);

    switch (e.keyCode) {
      case this.keys.right:
      case this.keys.left: {
        this.setReplaceMode();
        this.highlightCellBackground();
        break;
      }
      case this.keys.enter:
      case this.keys.tab: {
        e.preventDefault();
        return false;
      }
      case this.keys.esc:
      case this.keys.backspace: {
        return false;
      }
      case this.keys.up: {
        if (currentIndex > 0) {
          var prevOption = options.eq(currentIndex - 1);
          currentOption.removeClass('selected');
          prevOption.addClass('selected');
          scrollUpIfSelectionIsInvisible();
        }
        e.preventDefault();
        return false;
      }
      case this.keys.down: {
        if (currentIndex != options.length - 1) {
          var prevOption = options.eq(currentIndex + 1);
          options.eq(currentIndex).removeClass('selected');
          prevOption.addClass('selected');
          scrollDownIfSelectionIsInvisible();
        }
        e.preventDefault();
        return false;
      }
    }

    function scrollUpIfSelectionIsInvisible() {
      var currentOption = options.filter('.selected');
      var offsetTop = currentOption.offset().top - list.offset().top;
      if (offsetTop < 0) {
        list[0].scrollTop += offsetTop;
      }
    }


    function scrollDownIfSelectionIsInvisible() {
      var currentOption = options.filter('.selected');
      var offsetTop = currentOption.offset().top - list.offset().top;
      var positionBottom = offsetTop + currentOption.outerHeight();
      var containerHeight = list.height();
      if (containerHeight < positionBottom) {
        list[0].scrollTop += (positionBottom - containerHeight);
      }
    }
  }

  render() {
    var detail = null, list = null, contentEditable = false;
    if (this.state.functionDetail) {
      detail = <FunctionDetail key="function-detail"
                               function={this.state.functionDetail}
                               argIndex={this.state.argIndex} minimized={this.minimized}
                               toggleContent={this.toggleContent}/>;
    }

    if (this.state.functionAndDatasetList.length > 0) {
      list = <FunctionList functionAndDatasetList={this.state.functionAndDatasetList}/>;
    }

    if (this.props.formula.type) contentEditable = true;

    let style = {
      position: "absolute",
      zIndex: 100000,
      background: "white",
      width: "400px"
    };

    return (
      <div className="formula-bar-wrapper">
        <div className="formula-bar"
             id="formula-bar"
             ref="formulaBar"
             contentEditable={contentEditable}
             spellCheck="false"
             tabIndex="0"
             role="combobox"
             aria-labelledby="formula-bar"
             aria-autocomplete="inline"
             aria-owns="formula-list"
             onClick={this.handleClick}
             onKeyDown={this.handleKeyDown}
             onKeyUp={this.handleKeyUp}></div>
        <ReactCSSTransitionGroup transitionName="example"
                                 transitionEnterTimeout={500}
                                 transitionLeaveTimeout={300} component="div" style={style}>
          {list}
          {detail}
        </ReactCSSTransitionGroup>
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/analytic-studio/spreadsheet/formulaBar.jsx